<template>
  <div>
    <sc-notification />
    <sc-header
      v-if="screenMode !== screenModes.SIMPLE"
      :remote-access-info="remoteAccess" />
    <main
      class="main"
      :class="[screenModeCls,spacingEnvCls]">
        <div
          :class="{'main__menu': !newMenu, 'main__menu__new': newMenu}"
          v-if="screenMode === screenModes.NORMAL">
            <sc-nav v-if="!newMenu"/>
            <sc-menu @getmenustate="setMenuState" v-if="newMenu"/>
        </div>
        <div
          :class="[
            menuState ? 'main__menu__new--spacing': 'main__menu__new--nospacing',
            newMenu && screenMode === screenModes.NORMAL ? 'main__content__new': 'main__content'
          ]">
            <article
              v-if="getDiffDays <= 120 && screenMode !== screenModes.SIMPLE"
              class="message is-warning message-remote-access is-marginless">
              <div class="message-body">
                {{alertMessageNewMenu}}
                <sc-switch
                  size="is-small"
                  v-model="newMenu"
                  @input="toggleMenu">
                </sc-switch>
              </div>
            </article>
            <router-view/>
        </div>
    </main>
  </div>
</template>
<script>
  import { createNamespacedHelpers } from 'vuex';

  import {
    ScNav,
    ScSwitch,
    ScMenu,
    ScDialog,
  } from '@intelipost-js/secure-components';
  import { Auth, Storage, Enums, Moment, Lodash } from '@intelipost-js/secure-providers';
  import ScEnvironment from '@/components/sc-environment/ScEnvironment';
  import ScHeader from '@/components/sc-header/ScHeader';
  import ScNotification from '@/components/sc-notification/ScNotification';
  import { BroadcastChannel } from 'broadcast-channel';

  const { mapMutations } = createNamespacedHelpers('permissions');

  export default {
    name: 'page-home',
    data() {
      return {
        menuState: true,
        hasPopUp: false,
        newMenu: false,
        screenModes: Enums.ScreenModes,
        isTest: Auth.getUser() && !Auth.getUser().is_production,
        remoteAccess: {
          active: false,
          user: {},
        },
        fixedStartDate: Moment('01/10/2020 00:00', 'DD/MM/YYYY HH:mm').toISOString(),
      };
    },
    computed: {
      screenMode() {
        const { meta } = this.$route;
        return (meta && meta.screenMode && this.screenModes[meta.screenMode]) ?
          meta.screenMode : this.screenModes.NORMAL;
      },
      screenModeCls() {
        return `main-${this.screenMode.toLowerCase()}`;
      },
      spacingEnvCls() {
        let cls = '';
        if (this.remoteAccess.active && !this.isTest) {
          cls = 'main_spacing__alert';
        }
        if (this.remoteAccess.active && this.isTest) {
          cls = 'main_spacing__alertenv';
        }
        if (!this.remoteAccess.active && !this.isTest) {
          cls = 'main_spacing__noalert';
        }
        if (!this.remoteAccess.active && this.isTest) {
          cls = 'main_spacing__noalertenv';
        }
        if (this.screenMode === 'SIMPLE') {
          cls = 'main_spacing__no-header';
        }
        return cls;
      },
      getDiffDays() {
        return Moment().diff(this.fixedStartDate, 'days');
      },
      alertMessageNewMenu() {
        if (this.newMenu) {
          return 'Você está usando o novo menu! Se ainda quiser visualizar o antigo, clique aqui';
        }
        return 'O menu lateral foi reformulado. Clique aqui para utilizá-lo';
      },
    },
    methods: {
      ...mapMutations([
        'setEnvVisibility',
      ]),
      setMenuState(menuState) {
        this.menuState = menuState;
      },
      isRemoteAccess() {
        const remoteAccess = Storage.get('RemoteAccess');
        if (remoteAccess) {
          const { status } = remoteAccess;
          if (status) {
            Object.assign(this.remoteAccess, {
              active: status,
              user: Auth.getUser(),
            });
          }
        }
      },
      startHeap() {
        if (window.heap && window.heap.load) {
          const envs = ['production', 'tim'];
          if (envs.includes(process.env.NODE_ENV)) {
            window.heap.load('3670954001');
          } else {
            window.heap.load('262634513');
          }
          const {
            first_name,
            last_name,
            email,
            client_id,
            company_id,
            user_group_id,
          } = Auth.getUser();
          window.heap.addUserProperties({
            Name: `${first_name} ${last_name}`,
            Email: email,
            'Company ID' : company_id, //eslint-disable-line
            'Client ID' : client_id, //eslint-disable-line
            'User Group ID': user_group_id, //eslint-disable-line
          });
          window.heap.identify(client_id);
        }
      },
      startIntercom() {
        if (window.Intercom && !this.remoteAccess.active) {
          this.$store.dispatch('intercom/getInfoUser')
            .then(userIntercom => window.Intercom('boot', Object.assign(userIntercom, {
              user_agent_data: navigator.userAgent,
              referrer: location.href,
            })));
        }
      },
      getClient() {
        const client = Storage.get('client');
        if (!client) {
          this.$store.dispatch('client/getClient');
        }
        return null;
      },
      toggleMenu() {
        if (this.newMenu) {
          Storage.set('originMenu', 'newmenu', 'local');
        } else {
          Storage.set('originMenu', 'oldmenu', 'local');
        }
        Auth.setMenu().then(() => window.location.reload());
      },
      getEnvStatus() {
        const {
          hide_environment,
        } = Storage.get('user') || {};
        if (Lodash.isUndefined(hide_environment)) {
          return this.$store.dispatch('permissions/getEnvStatus');
        }
        this.setEnvVisibility(hide_environment);
        return null;
      },
      getPermissions() {
        const {
          permissions,
          migrated,
        } = Storage.get('user') || {};
        if (migrated) {
          if (!permissions) {
            return this.$store.dispatch('permissions/getModulesPermissions');
          }
          return null;
        }
        return null;
      },
    },
    created() {
      const channel = new BroadcastChannel('loginTab');
      channel.onmessage = () => {
        if (!this.hasPopUp) {
          ScDialog.alert({
            title: 'Esta sessão já foi encerrada!',
            message: '<strong id="multipleRemoteLoginDetected" >Mas não se preocupe!</strong> Ao clicar em "Acessar Intelipost" você poderá continuar utilizando o TMS normalmente',
            confirmText: 'Acessar Intelipost',
            onConfirm: () => {
              location.reload();
            },
          });
          this.hasPopUp = true;
        }
      };

      this.isRemoteAccess();
      this.startIntercom();
      this.getEnvStatus();
      this.getPermissions();
      this.startHeap();
      this.getClient();
      this.newMenu = Storage.get('originMenu', 'local') === 'newmenu';
    },
    components: {
      ScEnvironment,
      ScHeader,
      ScNotification,
      ScNav,
      ScSwitch,
      ScMenu,
      ScDialog,
    },
  };
</script>
<style lang="scss" scoped>
  @import "~@intelipost-js/secure-ui/src/scss/variables"; //eslint-disable-line
  .message-remote-access {
    margin-bottom: 0;
  }
  .main {
    display: flex;
    overflow-y: initial;
    max-height: 100%;
    min-height: 100vh;
  }
  .main__menu {
    flex: 0 0 auto;
  }
  .main__menu__new{
    background: #e7e7e7;
    position: fixed;
    z-index: 8;
    height: 100%;
    &--spacing {
      padding: .75rem .75rem 6rem 17.3rem;
    }
    &--nospacing {
      padding: .75rem .75rem 6rem 4.6rem;
    }
  }
  .main__content{
    position: relative;
    background-color: #F7F7F7;
    font-size: 14px;
    flex: 1 auto;
    padding: .75rem .75rem 6rem;
    width: 80%;
  }
  .main__content__new {
    position: relative;
    background-color: #F7F7F7;
    font-size: 14px;
    flex: 1 auto;
    width: 100%;
    @media(max-width: 768px) {
      padding: .75rem .75rem 6rem 4.6rem;
    }
  }
  @media(max-width: 768px) {
    .main:not(.main-simple) {
      .main__content{
        margin-left: 3.15rem;
      }
    }
  }
  .main_spacing {
    &__no-header {
      padding-top: 0;
      --header-height: 0;
    }
    &__alert {
      padding-top: 8.8rem;
      --header-height: 124px;
      @media(max-width: 906px) {
        padding-top: 10.4rem;
        --header-height: 146px;
      }
      @media(max-width: 768px) {
        padding-top: 10.2rem;
        --header-height: 136px;
      }
      @media(max-width: 472px) {
        padding-top: 11.6rem;
        --header-height: 158px;
      }
      @media(max-width: 378px) {
        padding-top: 13.2rem;
        --header-height: 178px;
      }
    }
    &__alertenv {
      padding-top: 10rem;
      --header-height: 140px;
      @media(max-width: 906px) {
        padding-top: 11.4rem;
        --header-height: 162px;
      }
      @media(max-width: 768px) {
        padding-top: 10.8rem;
        --header-height: 154px;
      }
      @media(max-width: 472px) {
        padding-top: 12rem;
        --header-height: 176px;
      }
      @media(max-width: 378px) {
        padding-top: 13.5rem;
        --header-height: 196px;
      }
    }
    &__noalert {
      padding-top: 4.85rem;
      --header-height: 68px;
      @media(max-width: 768px) {
        padding-top: 4.2rem;
        --header-height: 60px;
      }
    }
    &__noalertenv {
      padding-top: 6rem;
      --header-height: 86px;
      @media(max-width: 768px) {
        padding-top: 5.35rem;
        --header-height: 78px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/features/private/home/PageHome.vue?aa02f146